import React from 'react';
import {
  AutocompleteDropdown,
  Box,
  Controller,
  ControllerWrapper,
  FieldWrapper,
  FormFieldsContainer,
  Label,
  RegularField,
  useFormContext,
} from '@common-fe/common-fe';

import { MAX_OPTIONS_COUNT_STATES, useStatesQuery } from '@/modules/core/hooks';

import { EditAddressField, EditAddressFormData } from './useEditAddressForm';

const EditAddressFormFields: React.FC = () => {
  const { control, formState: { errors } } = useFormContext<EditAddressFormData>();
  const { states } = useStatesQuery();

  return (
    <Box data-testid="edit-address-form-fields" pad="spacing24">
      <FormFieldsContainer>
        <FieldWrapper>
          <Label name={EditAddressField.street} showRequireIcon isNarrow>
            Address line 1
          </Label>
          <ControllerWrapper errorText={errors?.street?.message}>
            <Controller
              name={EditAddressField.street}
              control={control}
              render={({ field: { value, onChange, name } }) => (
                <RegularField
                  testId="edit-address_street"
                  editMode
                  placeholder="Enter Address line 1"
                  isError={!!errors?.street?.message}
                  onChange={onChange}
                  value={value}
                  name={name}
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={EditAddressField.street_2} isNarrow>
            Address line 2
          </Label>
          <Controller
            name={EditAddressField.street_2}
            control={control}
            render={({ field: { value, onChange, name } }) => (
              <RegularField
                testId="edit-address_street-2"
                editMode
                placeholder="Enter Address line 2"
                onChange={onChange}
                value={value}
                name={name}
              />
            )}
          />
        </FieldWrapper>

        <FieldWrapper>
          <Label name={EditAddressField.city} showRequireIcon isNarrow>
            City
          </Label>
          <ControllerWrapper errorText={errors?.city?.message}>
            <Controller
              name={EditAddressField.city}
              control={control}
              render={({ field: { value, onChange, name } }) => (
                <RegularField
                  testId="edit-address_city"
                  editMode
                  placeholder="Enter City"
                  isError={!!errors?.city?.message}
                  onChange={onChange}
                  value={value}
                  name={name}
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={EditAddressField.state} showRequireIcon isNarrow>
            State
          </Label>
          <ControllerWrapper errorText={errors?.state?.message}>
            <Controller
              name={EditAddressField.state}
              control={control}
              render={({ field: { value, onChange, name } }) => (
                <AutocompleteDropdown
                  testId="edit-address_state"
                  name={name}
                  options={states}
                  maxOptionsCount={MAX_OPTIONS_COUNT_STATES}
                  placeholder="Select state"
                  value={value}
                  onChange={onChange}
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>

        <FieldWrapper>
          <Label name={EditAddressField.zipCode} showRequireIcon isNarrow>
            ZIP code
          </Label>
          <ControllerWrapper errorText={errors?.zipCode?.message}>
            <Controller
              name={EditAddressField.zipCode}
              control={control}
              render={({ field: { value, onChange, name } }) => (
                <RegularField
                  testId="edit-address_zip-code"
                  editMode
                  placeholder="Enter ZIP code"
                  isError={!!errors?.zipCode?.message}
                  onChange={onChange}
                  value={value}
                  name={name}
                />
              )}
            />
          </ControllerWrapper>
        </FieldWrapper>
      </FormFieldsContainer>
    </Box>
  );
};

export default EditAddressFormFields;
